var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpDeskActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_515)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_567_515",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_567_515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 12.8H17.5544L17.3152 10.828C17.2416 9.876 16.5 9.1088 15.56 9.0048L14.292 8.8352L14.06 8.2048C14.412 7.7648 14.6284 7.2112 14.6392 6.6076C15.122 6.498 15.5076 6.116 15.584 5.634C15.5944 5.5688 15.594 5.504 15.594 5.4396H15.5996V3.5996C15.5996 2.6412 15.226 1.7372 14.5452 1.0516C13.8624 0.3736 12.9584 0 12 0C10.0152 0 8.4004 1.6148 8.4004 3.6V5.44H8.4056C8.4056 5.5048 8.4052 5.5696 8.4156 5.6344C8.492 6.116 8.8776 6.498 9.3604 6.608C9.3712 7.2116 9.5876 7.7652 9.9396 8.2052L9.7076 8.8356L8.4484 9.004C7.4996 9.1092 6.7576 9.8764 6.686 10.8112L6.4452 12.8004H0.8C0.3588 12.8004 0 13.1592 0 13.6004V14.4004C0 14.8416 0.3588 15.2004 0.8 15.2004H1.2V22.8004C1.2 23.462 1.7384 24.0004 2.4 24.0004H21.6C22.2616 24.0004 22.8 23.462 22.8 22.8004V15.2004H23.2C23.6412 15.2004 24 14.8416 24 14.4004V13.6004C24 13.1592 23.6412 12.8 23.2 12.8ZM13.5988 9.268C13.584 9.7064 13.4252 10.0828 13.138 10.3604C12.8452 10.6436 12.4408 10.8 12 10.8C11.0956 10.8 10.4332 10.1596 10.4012 9.268L10.58 8.7824C10.9904 9.0456 11.4772 9.2 12 9.2C12.5228 9.2 13.0096 9.0456 13.42 8.7824L13.5988 9.268ZM12 0.8C12.7456 0.8 13.4496 1.0912 13.98 1.6176C14.5088 2.1504 14.8 2.8544 14.8 3.6V4.3108C14.7476 4.2924 14.6948 4.2752 14.64 4.264V4.0868C14.64 3.7148 14.4804 3.362 14.2012 3.118C13.9224 2.874 13.552 2.7612 13.1824 2.8116C12.4752 2.906 11.5244 2.906 10.8176 2.8116C10.4484 2.7616 10.0776 2.8736 9.7988 3.118C9.52 3.3616 9.36 3.7148 9.36 4.0868V4.264C9.3052 4.2752 9.2524 4.292 9.2004 4.3104V3.6C9.2004 2.0564 10.4564 0.8 12 0.8ZM9.6456 5.84C9.4284 5.84 9.2352 5.6948 9.2052 5.5088C9.186 5.3876 9.218 5.2712 9.2952 5.1808C9.3716 5.0912 9.4828 5.04 9.6 5.04H9.76C9.9812 5.04 10.16 4.8612 10.16 4.64V4.0868C10.16 3.944 10.2184 3.8132 10.3256 3.72C10.4324 3.6268 10.5692 3.5852 10.7112 3.6048C11.4884 3.7088 12.5112 3.7088 13.2884 3.6048C13.43 3.5844 13.5676 3.6264 13.674 3.72C13.7812 3.8132 13.8396 3.944 13.8396 4.0868V4.64C13.8396 4.8612 14.0184 5.04 14.2396 5.04H14.3996C14.5168 5.04 14.6276 5.0912 14.7044 5.1808C14.7812 5.2716 14.8132 5.388 14.7944 5.5088C14.7648 5.6948 14.5712 5.84 14.354 5.84H14.2396C14.0184 5.84 13.8396 6.0188 13.8396 6.24V6.56C13.8396 7.5748 13.0144 8.4004 11.9996 8.4004C10.9848 8.4004 10.1596 7.5752 10.1596 6.56V6.24C10.1596 6.0188 9.9808 5.84 9.7596 5.84H9.6456ZM7.4824 10.89C7.526 10.3208 7.9696 9.862 8.546 9.7984L9.6404 9.652C9.8404 10.7892 10.7868 11.6004 11.9996 11.6004C12.6488 11.6004 13.2504 11.3644 13.6936 10.936C14.0452 10.596 14.2732 10.1504 14.3596 9.6524L15.4624 9.8C16.03 9.8624 16.4732 10.3216 16.5188 10.908L16.748 12.8008H7.2508L7.4816 10.8908L7.4824 10.89ZM22 22.8C22 23.0208 21.8208 23.2 21.6 23.2H2.4C2.1792 23.2 2 23.0208 2 22.8V15.2H22V22.8ZM23.2 14.4H0.8V13.6H23.2V14.4Z",
    fill: "url(#paint0_linear_567_515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20005 21.6008C5.42125 21.6008 5.60005 21.422 5.60005 21.2008V19.6008H7.20005V21.2008C7.20005 21.422 7.37885 21.6008 7.60005 21.6008C7.82125 21.6008 8.00005 21.422 8.00005 21.2008V17.2008C8.00005 16.9796 7.82125 16.8008 7.60005 16.8008C7.37885 16.8008 7.20005 16.9796 7.20005 17.2008V18.8008H5.60005V17.2008C5.60005 16.9796 5.42125 16.8008 5.20005 16.8008C4.97885 16.8008 4.80005 16.9796 4.80005 17.2008V21.2008C4.80005 21.422 4.97885 21.6008 5.20005 21.6008Z",
    fill: "url(#paint1_linear_567_515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20005 21.6008H11.2C11.4212 21.6008 11.6 21.422 11.6 21.2008C11.6 20.9796 11.4212 20.8008 11.2 20.8008H9.60005V19.6008H10.4C10.6212 19.6008 10.8 19.422 10.8 19.2008C10.8 18.9796 10.6212 18.8008 10.4 18.8008H9.60005V17.6008H11.2C11.4212 17.6008 11.6 17.422 11.6 17.2008C11.6 16.9796 11.4212 16.8008 11.2 16.8008H9.20005C8.97885 16.8008 8.80005 16.9796 8.80005 17.2008V21.2008C8.80005 21.422 8.97885 21.6008 9.20005 21.6008Z",
    fill: "url(#paint2_linear_567_515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 21.6008H14.8C15.0212 21.6008 15.2 21.422 15.2 21.2008C15.2 20.9796 15.0212 20.8008 14.8 20.8008H13.2V17.2008C13.2 16.9796 13.0212 16.8008 12.8 16.8008C12.5788 16.8008 12.4 16.9796 12.4 17.2008V21.2008C12.4 21.422 12.5788 21.6008 12.8 21.6008Z",
    fill: "url(#paint3_linear_567_515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 21.6004C16.6212 21.6004 16.8 21.4216 16.8 21.2004V19.6004H17.798C18.1708 19.6004 18.5224 19.4544 18.7856 19.1916C19.0528 18.9296 19.2 18.5768 19.2 18.1988C19.2 17.428 18.5712 16.8008 17.798 16.8008H16.4C16.1788 16.8008 16 16.9796 16 17.2008V21.2008C16 21.422 16.1788 21.6004 16.4 21.6004ZM16.8 17.6004H17.798C18.13 17.6004 18.4 17.8688 18.4 18.1984C18.4 18.36 18.338 18.5096 18.2232 18.6228C18.1084 18.7372 17.9572 18.8004 17.7984 18.8004H16.8004L16.8 17.6004Z",
    fill: "url(#paint4_linear_567_515)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_515",
    x1: 12,
    y1: 24.0004,
    x2: 12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6564,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_567_515",
    x1: 6.40005,
    y1: 21.6008,
    x2: 6.40005,
    y2: 16.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6564,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_567_515",
    x1: 10.2,
    y1: 21.6008,
    x2: 10.2,
    y2: 16.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6564,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_567_515",
    x1: 13.8,
    y1: 21.6008,
    x2: 13.8,
    y2: 16.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6564,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_567_515",
    x1: 17.6,
    y1: 21.6004,
    x2: 17.6,
    y2: 16.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6564,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDeskActive);
export default __webpack_public_path__ + "static/media/help-desk-active.a8c3a5d861fb2205e8ad722259ed01b1.svg";
export { ForwardRef as ReactComponent };